!function () {
  class ImageGallery extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    init() {
      const rightWrap = this.querySelector(".animate-right");
      const leftInner = this.querySelector(".animate-left");
      const styleTag = document.createElement("style");
      document.head.appendChild(styleTag);

      const recalc = () => {
        const isDesktop = window.matchMedia("(min-width: 768px)").matches;
        const itemSize = isDesktop ? 348 : 172;
        const gap = isDesktop ? 12 : 8;

        const oneSlider = this.querySelector(".slider");
        const n = oneSlider ? oneSlider.querySelectorAll(".slider-item").length : 0;
        if (!n) return;

        // Width of one slider set (n items + n-1 internal gaps)
        const setWidth = n * itemSize + (n - 1) * gap;
        // Total period for a seamless loop cycle (n items + n gaps)
        const loopDistance = n * (itemSize + gap);

        // Apply width to each slider set so flexbox doesn't shrink them
        if (rightWrap) {
          rightWrap
            .querySelectorAll(".slider")
            .forEach((s) => (s.style.width = `${setWidth}px`));
        }
        if (leftInner) {
          leftInner
            .querySelectorAll(".slider")
            .forEach((s) => (s.style.width = `${setWidth}px`));
        }

        styleTag.textContent = `
          @keyframes marquee {
            0% { transform: translate3d(-${loopDistance}px, 0, 0); }
            100% { transform: translate3d(0, 0, 0); }
          }
          @keyframes marqueeLeft {
            0% { transform: translate3d(0, 0, 0); }
            100% { transform: translate3d(-${loopDistance}px, 0, 0); }
          }
        `;
      };

      recalc();

      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(recalc, 150);
      });

      const animatedEls = [rightWrap, leftInner].filter(Boolean);
      if ("IntersectionObserver" in window && animatedEls.length) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              animatedEls.forEach((el) => {
                el.style.animationPlayState = entry.isIntersecting
                  ? "running"
                  : "paused";
              });
            });
          },
          { threshold: 0 }
        );
        io.observe(this);
      }
    }
  }

  customElements.define("image-gallery", ImageGallery);
}();